import { memo } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { pickingRoutes } from "../../../../router/routesConstants";
import CustomButton from "../../../../components/CustomButton";

import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import SvgIcon from "../../../../helpers/SvgIcon";

function OrdersByDayTableActionButtons({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const goToDeliveryArrangement = () => {
    return `/${pickingRoutes.picking}/${pickingRoutes.deliveryArrangement}?ruta=${crudData?.ruta}`;
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        tooltipTitle="Dispozitii de livrare"
        className="mx-1 mb-1"
        navigate={goToDeliveryArrangement()}>
        <SvgIcon type="SPLIT_LIST" />
      </CustomButton>
    </div>
  );
}

export default memo(OrdersByDayTableActionButtons);
